import {Pipe, PipeTransform} from '@angular/core';
import {ValidityPeriod} from '../generated-admin-types';

@Pipe({
  name: 'couponPeriod',
})
export class CouponPeriodPipe implements PipeTransform {
  transform(period: ValidityPeriod) {
    if (period?.type === 'temporalInterval') {
      return `${new Date(period.startTime).toLocaleDateString()}至${new Date(period.endTime).toLocaleDateString()}`;
    } else if (period?.type === 'validDays') {
      return `自领取${period.numberOfDays}天`;
    } else {
      return '长期有效';
    }
  }
}
